import { render, staticRenderFns } from "./dashboard-items-summary.vue?vue&type=template&id=4424d9d5&scoped=true"
import script from "./dashboard-items-summary.vue?vue&type=script&lang=js"
export * from "./dashboard-items-summary.vue?vue&type=script&lang=js"
import style0 from "./dashboard-items-summary.vue?vue&type=style&index=0&id=4424d9d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4424d9d5",
  null
  
)

export default component.exports